module.exports = __webpack_public_path__ + "static/media/Placeholder.bc7a495d.png";